<div class="bulk-bar" role="region" [attr.aria-label]="'common.selected' | translate">
  <!-- Selection count -->
  <div class="bulk-bar__count" aria-live="polite" aria-atomic="true">
    <span class="bulk-bar__count-badge">{{ count }}</span>
    <span class="bulk-bar__count-label">{{ "common.selected" | translate }}</span>
  </div>

  <span class="bulk-bar__divider" aria-hidden="true"></span>

  <!-- Host-provided actions -->
  <div class="bulk-bar__actions">
    <ng-content></ng-content>
  </div>

  <!-- Clear selection -->
  <ng-container *ngIf="showClear">
    <span class="bulk-bar__divider" aria-hidden="true"></span>
    <button
      type="button"
      class="bulk-bar__clear"
      [matTooltip]="'common.clear_selection' | translate"
      matTooltipPosition="below"
      [attr.aria-label]="'common.clear_selection' | translate"
      (click)="cleared.emit()"
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path d="M10.5 3.5 3.5 10.5M3.5 3.5l7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>
    </button>
  </ng-container>
</div>
